import { render, staticRenderFns } from "./bill-use.vue?vue&type=template&id=50f32a89&scoped=true"
import script from "./bill-use.vue?vue&type=script&lang=js"
export * from "./bill-use.vue?vue&type=script&lang=js"
import style0 from "./bill-use.vue?vue&type=style&index=0&id=50f32a89&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f32a89",
  null
  
)

export default component.exports